export default __webpack_public_path__ + "static/media/rarity-rate-kat3.be7b2ff9.svg";